import { useEffect, useState } from "react"
import { CartPaymentMethods } from "../../storeApi"

// one request for the same cart, whoever asks (the cart's footer, the payment step)
let last = { key: "", promise: null }
const methodsFor = (cart, key) => {
  if (last.key !== key) last = { key, promise: CartPaymentMethods(cart.map((line) => ({ pid: line.pid, quantity: line.quantity || 1 }))).then((result) => (result && typeof result.online === "boolean" ? result : null)).catch(() => null) }
  return last.promise
}

// before the answer, and when there is none: online, as the store has always taken it
const ONLINE = { online: true, cashOnDelivery: false }

/**
 * The ways this cart can be paid (store {cart_payment_methods}): online when every seller in it
 * takes it, cash on delivery when it holds goods that travel and every seller takes it. Asked again
 * whenever its products change.
 */
export function useCartPaymentMethods(cart) {
  const [methods, setMethods] = useState(ONLINE)
  const key = (cart || []).map((line) => line.pid).sort().join(",")
  useEffect(() => {
    if (!cart?.length) return setMethods(ONLINE)
    let alive = true
    methodsFor(cart, key).then((answer) => alive && setMethods(answer || ONLINE))
    return () => {
      alive = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key])
  return methods
}
